import { send } from 'server';

import * as Types from '../../types';

export const getLoginHistory = ({
    returnTotalCount, pageId, loginDateBeforeDate, loginDateAfterDate
}: Types.TGetLoginHistoryRequest): Promise<Types.TLoginHistoryResponse> => send({
    ID: 35881,
    description: 'Get Login History',
    responses: [35882, 35883],
    loginCriteria: {
        loginDateBeforeDate,
        loginDateAfterDate
    },
    pagingParams: {
        ...pageId && { pageId },
        ...pageId && { pageSize: 30 },
        returnTotalCount
    }
});
